import * as React from "react";
import { bindActionCreators } from 'redux';
import { useEffect, useReducer, useRef, useState } from 'react';
import Autosuggest from 'react-autosuggest';
import { connect } from 'react-redux';
import { SiteSearchService, Suggestion } from '../services/SiteSearchService';
import * as SiteSearchStore from '../store/SiteSearchStore';
import { ApplicationState } from "../store";
import _uniqueId from 'lodash/uniqueId';

type Props = {
    searchPageUrl: string;
    searchStoreActions: typeof SiteSearchStore.actionCreators;
    searchStoreState: SiteSearchStore.IState
}

type State = {
    keywords: string;
    suggestions: Suggestion[];
}

const initialState: State = {
    keywords: '',
    suggestions: []
}

const SearchWithSuggestions = (props: Props) => {

    const [state, setState] = useReducer(
        (prevState: State, newState: Partial<State>) => ({ ...prevState, ...newState }),
        initialState
    );

    const [id] = useState(_uniqueId('headerSearch-'));


    const onSuggestionsFetchRequested = async ({ value }) => {
        //console.log('onSuggestionsFetchRequested ', value);

        const result = await SiteSearchService.getSuggestions(value);

        if (!result.errors) {
            setState({ suggestions: result.value });
        }
    }

    const onSuggestionsClearRequested = async () => {
        //console.log('onSuggestionsClearRequested ');
        setState({ suggestions: [] });
    }

    const getSuggestionValue = (suggestion: Suggestion) => {

        //console.log('getSuggestionValue ', suggestion);
        return suggestion.value;
    };

    const onSuggestionSelected = (suggestion: Suggestion) => {

        //console.log('onSuggestionSelected ', suggestion);
        //return suggestion.value;
        redirect(suggestion.value);
    };

    const shouldRenderSuggestions = (value, reason) => {
        console.log('shouldRenderSuggestions ', value, reason);

        return true;
    }

    const renderSuggestion = (suggestion: Suggestion) => (
        <div dangerouslySetInnerHTML={{ __html: suggestion.value.replace(state.keywords, '<b>' + state.keywords + '</b>') }}
            onClick={(e) => { e.preventDefault(); redirect(suggestion.value); }}>
        </div>
    );

    const onChange = (event, { newValue }) => {
        setState({
            keywords: newValue
        });
    };

    const redirect = (value: string) => {

        if (!value)
            return;

        if (props.searchPageUrl.substring(location.origin.length) == location.pathname) {
            // if we are on search page already
            props.searchStoreActions.updateSearchKeywords(value);

        } else {
            window.location.href = props.searchPageUrl + '?q=' + encodeURIComponent(value);
        }
    }


    return (
        <div className="d-flex">
            <label id={id} className="visually-hidden">Search</label>
            <Autosuggest
                suggestions={state.suggestions}
                onSuggestionsFetchRequested={onSuggestionsFetchRequested}
                onSuggestionsClearRequested={onSuggestionsClearRequested}
                getSuggestionValue={getSuggestionValue}
                renderSuggestion={renderSuggestion}
                onSuggestionSelected={onSuggestionSelected}
                //shouldRenderSuggestions={shouldRenderSuggestions}
                containerProps={{
                    className: 'site-search-suggest',
                    'aria-labelledby': id
                }}
                renderSuggestionsContainer={({ containerProps, children }) => {
                    //console.log('renderSuggestionsContainer', children, containerProps);
                    return (children) ?
                        (<div {...containerProps}>
                            {children}
                        </div>)
                        : null;
                }}
                inputProps={{
                    value: state.keywords,
                    onChange: onChange,
                    onKeyDown: (e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            redirect(state.keywords);
                            //console.log('enter key detected');
                        }
                    },
                    placeholder: 'Search',
                    className: 'form-control',
                    type: 'search'
                }}
            />
            <button className="btn-search-icon" type="submit">Search</button>
        </div>
    )
}

export default connect(
    (state: ApplicationState) => ({
        searchStoreState: state.siteSearchStore
    }), // Selects which state properties are merged into the component's props
    (dispatch, getState) => ({
        searchStoreActions: bindActionCreators(SiteSearchStore.actionCreators, dispatch)
    })

)(SearchWithSuggestions as any);